import { render, staticRenderFns } from "./VeHrPerformanceRuleModal.vue?vue&type=template&id=3547f7da"
import script from "./VeHrPerformanceRuleModal.vue?vue&type=script&lang=js"
export * from "./VeHrPerformanceRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports